namespace Matrix.Data {
    export interface ExtensionFieldDeleteRequest extends Serenity.ServiceRequest {
        TableSchema?: string;
        Tablename?: string;
        FieldName?: string;
    }
}
